import { Injectable } from '@angular/core';
import { transformToArray } from '@lyceo/shared/util';
import { Observable, map, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly permissions$: BehaviorSubject<string[]> =
    new BehaviorSubject<string[]>([]);

  public addPermission(permission: string | string[]): void {
    const permissions: string[] = transformToArray<string>(permission);
    const storedPermissions: string[] = this.permissions$
      .getValue()
      .filter((p) => !permissions.includes(p));

    this.permissions$.next([...storedPermissions, ...permissions]);
  }

  public hasPermission(permission: string | string[]): Observable<boolean> {
    const permissions: string[] = transformToArray<string>(permission);

    return this.permissions$.pipe(
      map((storedPermissions) =>
        this.hasPermissionCheck(permissions, storedPermissions),
      ),
    );
  }

  private hasPermissionCheck(
    permissions: string[],
    storedPermissions: string[],
  ): boolean {
    return permissions.some((permission) =>
      storedPermissions.includes(permission),
    );
  }
}
